export type PatientPageInfo = {
  page: number;
  totalPage: number;
  totalCount: number;
  perPage: number;
  searchWord: string | null;
  latestMessageCreatedAt: Date | null;
  answered: boolean | null;
  isFollowingUp: boolean | null;
  practitionerId: string | null;
  orderBy: { field: 'latest_message_created_at'; direction: 'asc' | 'desc' };
};

type NewPatientFields = {
  familyName: string;
  givenName: string;
  phoneticFamilyName: string;
  phoneticGivenName: string;
  birthDate: string;
  sex: string;
  mobilePhone: string;
};

export type QrCodePatient = {
  familyName: string;
  givenName: string;
  phoneticFamilyName: string;
  phoneticGivenName: string;
  birthDate: string;
  sex: string;
};

export type NewPatientDrawerState = {
  currentPanel: (typeof NewPatientPanelMap)[keyof typeof NewPatientPanelMap];
  inputValue: NewPatientFields | null;
  qrCodePatient: QrCodePatient | null;
  isOpen: boolean;
  page: number;
  perPage: number;
  totalPage: number;
  existingPhoneNumber: boolean;
};

export const NewPatientPanelMap = {
  input: 'input',
  inputFamily: 'inputFamily',
  confirm: 'confirm',
  select: 'select',
  checkin: 'checkin',
} as const;

export type NewPatientFromCheckinEntryDrawerState = {
  isOpen: boolean;
  checkinEntryId: string | null;
};

export type PrescriptionQrCodeReaderDialog = {
  isOpen: boolean;
};

export type SamePatientModal = {
  isOpen: boolean;
  patientId: string | null;
  guestPatientId: string | null;
};
